/**
 * 腾讯会议内部版本号
 */
export default function tencentAppVersion(userAgent: string) {
  let res = '';
  const ua = userAgent.toLowerCase();
  // 不是企业微信
  const regStrSaf = /app_version\/[\d._]*/gi;
  const verinfo = ua.match(regStrSaf);
  if (verinfo && verinfo.length > 0) {
    [, res] = verinfo[0].split('/');
  }
  return res;
}
